export const innovationIntelligence = (api) => ({
  getLists(success, fail) {
    api.authenticatedRequest('GET', '/innovationintelligence/lists', null, success, fail);
  },
  createList(data, success, fail) {
    api.authenticatedRequest('PUT', '/innovationintelligence/lists', data, success, fail);
  },
  getList(listId, success, fail) {
    api.authenticatedRequest('GET', `/innovationintelligence/lists/${listId}`, null, success, fail);
  },
  updateList(listId, data, success, fail) {
    api.authenticatedRequest('POST', `/innovationintelligence/lists/${listId}`, data, success, fail);
  },
  duplicateList(listId, data, success, fail) {
    api.authenticatedRequest('PUT', `/innovationintelligence/lists/${listId}`, data, success, fail);
  },
  deleteList(listId, success, fail) {
    api.authenticatedRequest('DELETE', `/innovationintelligence/lists/${listId}`, null, success, fail);
  },
  shareList(listId, userId, success, fail) {
    api.authenticatedRequest('POST', `/innovationintelligence/lists/${listId}/share/${userId}`, null, success, fail);
  },
  shareListMulti(listId, data, success, fail) {
    api.authenticatedRequest('POST', `/innovationintelligence/lists/${listId}/share`, data, success, fail);
  },
  unshareList(listId, userId, success, fail) {
    api.authenticatedRequest('DELETE', `/innovationintelligence/lists/${listId}/share/${userId}`, null, success, fail);
  },
  createPowerbiDataset(listId, datasetType, workspaceId, workspaceName, success, fail) {
    api.authenticatedRequest('POST', `/innovationintelligence/lists/${listId}/powerbi/datasets`, { datasetType, workspaceId, workspaceName }, success, fail);
  },
  deletePowerbiDataset(listId, datasetId, success, fail) {
    api.authenticatedRequest('DELETE', `/innovationintelligence/lists/${listId}/powerbi/datasets/${datasetId}`, null, success, fail);
  },
  getListCompanies(listId, params, success, fail) {
    const urlParams = new URLSearchParams(params);
    api.authenticatedRequest('GET', `/innovationintelligence/lists/${listId}/companies?${urlParams.toString()}`, null, success, fail);
  },
  addListCompany(listId, companyId, success, fail) {
    api.journey.record('innovationIntelligence', { listId, companyId }, 'addedToList');
    api.authenticatedRequest('POST', `/innovationintelligence/lists/${listId}/companies/${companyId}`, null, success, fail);
  },
  addListCompanyMulti(listId, companyIds, success, fail) {
    api.journey.record('innovationIntelligence', { listId, companyIds }, 'addedToList');
    api.authenticatedRequest('POST', `/innovationintelligence/lists/${listId}/companies`, companyIds, success, fail);
  },
  removeListCompanyMulti(listId, companyIds, success, fail) {
    api.journey.record('innovationIntelligence', { listId, companyIds }, 'removedFromList');
    api.authenticatedRequest('DELETE', `/innovationintelligence/lists/${listId}/companies`, companyIds, success, fail);
  },
  removeListCompany(listId, companyId, success, fail) {
    api.journey.record('innovationIntelligence', { listId, companyId }, 'removedFromList');
    api.authenticatedRequest('DELETE', `/innovationintelligence/lists/${listId}/companies/${companyId}`, null, success, fail);
  },
  emailCompanies(listId, data, success, fail) {
    const params: {listId?: string} = {};
    if (listId) {
      params.listId = listId;
    }
    const urlParams = new URLSearchParams(params);
    api.authenticatedRequest('POST', `/innovationintelligence/companies/email?${urlParams.toString()}`, data, success, fail);
  },
  listCompaniesCsv(listId, data, success, fail) {
    api.authenticatedRequest('POST', `/innovationintelligence/lists/${listId}/companies/email/csv`, data, success, fail);
  },
  subscribeToList(listId, shouldSubscribe, success, fail) {
    api.authenticatedRequest(shouldSubscribe ? 'POST' : 'DELETE', `/innovationintelligence/lists/${listId}/subscribe`, null, success, fail);
  },
  getListNews(listId, page, success, fail) {
    api.authenticatedRequest('GET', `/innovationintelligence/lists/${listId}/news?page=${page}`, null, success, fail);
  },
  localSearch(params, success, fail) {
    const searchString = `?query=${params.query || ''}&location=${params.location || ''}&unspscCode=${params.unspscCode || ''}`;
    const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${searchString}`;
    window.history.pushState({ path: newUrl }, '', newUrl);
    api.journey.record('innovationIntelligence', params, 'searched');
    api.authenticatedRequest('GET', `/innovationintelligence/search/local${searchString}`, null, success, fail);
  },
  searchLocations(params, success, fail) {
    let searchString = '';
    if ('query' in params) {
      searchString += `?query=${params.query}`;
    } else if ('uuids' in params) {
      searchString += `?uuids=${params.uuids}`;
    }
    api.authenticatedRequest('GET', `/innovationintelligence/search/locations${searchString}`, null, success, fail);
  },
  searchCategories(params, success, fail) {
    let searchString = '';
    if ('query' in params) {
      searchString = `?query=${params.query}`;
    } else if ('uuids' in params) {
      searchString = `?uuids=${params.uuids}`;
    }
    api.authenticatedRequest('GET', `/innovationintelligence/search/categories${searchString}`, null, success, fail);
  },
  search(params, success, fail) {
    const queryParams = Object.entries(params).map(([key, value]) => {
      if (Array.isArray(value)) {
        return [key, value.join(',')];
      }
      return [key, `${value}`];
    }).filter(([, value]) => (value !== ''));
    const urlParams = new URLSearchParams(queryParams);
    api.journey.record('innovationIntelligence', params, 'searched');
    api.authenticatedRequest('GET', `/innovationintelligence/search?${urlParams.toString()}`, null, success, fail);
  },
  saveSearch(data, success, fail) {
    api.authenticatedRequest('POST', '/innovationintelligence/search', data, success, fail);
  },
  deleteSavedSearches(data: { searchIds: string[], searchType: string }, success, fail) {
    api.authenticatedRequest('DELETE', '/innovationintelligence/search', data, success, fail);
  },
  getSearchHistory(id, page, searchType, success, fail) {
    api.authenticatedRequest('GET', `/innovationintelligence/companies/search/group/${id}/history?page=${page}&type=${searchType}`, null, success, fail);
  },
  get(id, success, fail) {
    api.authenticatedRequest('GET', `/innovationintelligence/companies/${id}`, null, success, fail);
  },
  deepDive(id, taskContext, success, fail) {
    api.authenticatedRequest('GET', `/innovationintelligence/companies/${id}/deep_dive?taskContext=${taskContext}`, null, success, fail);
  },
  reHoist(id, success, fail) {
    api.authenticatedRequest('GET', `/innovationintelligence/companies/${id}/deep_dive?hoist=true&taskContext=onSearch`, null, success, fail);
  },
  getSectorialNews(id, success, fail) {
    api.authenticatedRequest('GET', `/innovationintelligence/companies/${id}/sectorial`, null, success, fail);
  },
  getFundingInfo(id, success, fail) {
    api.authenticatedRequest('GET', `/innovationintelligence/companies/${id}/research`, null, success, fail);
  },
  getExternalServices(id, services, success, fail) {
    api.authenticatedRequest('POST', `/innovationintelligence/companies/${id}/services`, { services }, success, fail);
  },
  getCreditsafeReport(id, creditsafeIdToUse, success, fail) {
    api.authenticatedRequest('GET', `/innovationintelligence/companies/${id}/creditsafe/report${creditsafeIdToUse ? `?creditsafeId=${creditsafeIdToUse}` : ''}`, null, success, fail);
  },
  getCreditsafeReportPdf(id, success, fail) {
    api.authenticatedRequest('GET', `/innovationintelligence/companies/${id}/creditsafe/pdf`, null, success, fail);
  },
  getNotes(id, success, fail) {
    api.authenticatedRequest('GET', `/innovationintelligence/companies/${id}/notes`, null, success, fail);
  },
  createNote(id, data, success, fail) {
    api.authenticatedRequest('PUT', `/innovationintelligence/companies/${id}/notes`, data, success, fail);
  },
  editNote(id, noteId, data, success, fail) {
    api.authenticatedRequest('POST', `/innovationintelligence/companies/${id}/notes/${noteId}`, data, success, fail);
  },
  deleteNote(id, noteId, success, fail) {
    api.authenticatedRequest('DELETE', `/innovationintelligence/companies/${id}/notes/${noteId}`, null, success, fail);
  },
  hide(id, toHide, success, fail) {
    api.authenticatedRequest(toHide ? 'POST' : 'DELETE', `/innovationintelligence/companies/${id}/hide`, null, success, fail);
  },
  getHidden(success, fail) {
    api.authenticatedRequest('GET', '/innovationintelligence/companies/hidden', null, success, fail);
  },
  getCountryLists(success, fail) {
    api.authenticatedRequest('GET', '/innovationintelligence/search/locations/lists', null, success, fail);
  },
  updateCompany(id, data, success, fail) {
    api.authenticatedRequest('PUT', `/innovationintelligence/companies/${id}`, data, success, fail);
  },
  inviteCompanies(data, success, fail) {
    api.authenticatedRequest('POST', '/innovationintelligence/companies/invite', data, success, fail);
  },
  getDashboards(success, fail) {
    api.authenticatedRequest('GET', '/innovationintelligence/dashboards', null, success, fail);
  },
  createDashboard(data, success, fail) {
    api.authenticatedRequest('PUT', '/innovationintelligence/dashboards', data, success, fail);
  },
  getDashboard(id, success, fail) {
    api.authenticatedRequest('GET', `/innovationintelligence/dashboards/${id}`, null, success, fail);
  },
  refreshDashboard(id, success, fail) {
    api.authenticatedRequest('POST', `/innovationintelligence/dashboards/${id}`, null, success, fail);
  },
  deleteDashboard(id, success, fail) {
    api.authenticatedRequest('DELETE', `/innovationintelligence/dashboards/${id}`, null, success, fail);
  },
  subscribeToDashboard(id, toSubscribe, success, fail) {
    api.authenticatedRequest(toSubscribe ? 'POST' : 'DELETE', `/innovationintelligence/dashboards/${id}/subscribe`, null, success, fail);
  },
  updateDashboardEventLocation(id, data, success, fail) {
    api.authenticatedRequest('POST', `/innovationintelligence/dashboards/${id}/eventLocation`, data, success, fail);
  },
  findCompaniesByCsv(data, success, fail) {
    api.authenticatedRequest('POST', '/innovationintelligence/companies/findByCsv', data, success, fail);
  },
  connectExcel(id, success, fail) {
    api.authenticatedRequest('POST', `/innovationintelligence/lists/${id}/microsoftExcel`, null, success, fail);
  },
  disconnectService(id, service, success, fail) {
    api.authenticatedRequest('DELETE', `/innovationintelligence/lists/${id}/${service}`, null, success, fail);
  },
});
